export default __webpack_public_path__ + "static/9-c06e444bb3949454fa1f093a00c25b8b.webp";